const blogPage = (data, smoother) => {
  
  /***************************************************************
    PARALLAX ITEMS
  ***************************************************************/
  
  const $container = $(data.next.container);
  const $blogItems = $container.find('.posts-grid > a');
    
  mm.add("(min-width: 41rem)", () => {
    
    if ($blogItems.length) {
      $blogItems.each(function (index, el) {
        smoother.effects(el, {speed: 1 + index * 0.025});
      });
    }
        
  }, '.blog');
  
}

export {
  blogPage
};
